// tree-cell-template.directive.ts
import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[treeFooterTemplate]',
  standalone: true,
})
export class TreeFooterTemplateDirective {
  @Input('treeFooterTemplate') name!: string; // e.g. "status", "link"

  constructor(public template: TemplateRef<unknown>) {}
}
